import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.OurServices.heading',
    defaultMessage: 'Nasze usługi:'
  }
});



// WEBPACK FOOTER //
// ./src/views/Home/Sections/OurServices/OurServices.intl.js